import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../services/api'
import { useAuthStore } from '../useAuthStore'
import type { ParentDashboardData, AdminDashboardData } from '../../types/api'

/**
 * Hook for parent dashboard data
 */
export const useParentDashboard = () => {
  const { user, token } = useAuthStore()
  
  return useQuery({
    queryKey: ['dashboard', 'parent'],
    queryFn: async () => {
      const response = await apiClient.get<ParentDashboardData>('/dashboard/parent')
      return response.data
    },
    // Only run the query if user is authenticated and is a parent
    enabled: !!token && !!user && user.type === 'parent',
    staleTime: 2 * 60 * 1000, // 2 minutes
    retry: false, // Don't retry failed requests to avoid console spam
    refetchOnWindowFocus: true
  })
}

/**
 * Hook for admin dashboard data
 */
export const useAdminDashboard = () => {
  const { user, token } = useAuthStore()
  
  return useQuery({
    queryKey: ['dashboard', 'admin'],
    queryFn: async () => {
      const response = await apiClient.get<AdminDashboardData>('/dashboard/admin')
      return response.data
    },
    // Only run the query if user is authenticated and is an admin
    enabled: !!token && !!user && user.type === 'admin',
    staleTime: 1 * 60 * 1000, // 1 minute for more frequent updates
    retry: false, // Don't retry failed requests to avoid console spam
    refetchOnWindowFocus: true
  })
}